import { iconFactory } from '../iconFactory'

export const Activity = iconFactory(
  'Activity',
  ({ fill }) => (
    <path
      d="M14.1667 3.99967C12.4267 4.46634 10.3867 4.66634 8.5 4.66634C6.61333 4.66634 4.57333 4.46634 2.83333 3.99967L2.5 5.33301C3.74 5.66634 5.16667 5.88634 6.5 5.99967V14.6663H7.83333V10.6663H9.16667V14.6663H10.5V5.99967C11.8333 5.88634 13.26 5.66634 14.5 5.33301L14.1667 3.99967ZM8.5 3.99967C9.23333 3.99967 9.83333 3.39967 9.83333 2.66634C9.83333 1.93301 9.23333 1.33301 8.5 1.33301C7.76667 1.33301 7.16667 1.93301 7.16667 2.66634C7.16667 3.39967 7.76667 3.99967 8.5 3.99967Z"
      fill={fill}
    />
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
